// React Component (or JSX)

import React from 'react';
import './App.css'; // Assuming you have a CSS file for styles

const Rwightman_pull_mlfoundations_open_clip_pull_1069_From_2025_04_01_To_2025_04_30 = () => {
  return (
    <>
     <a
        href="https://github.com/rwightman?tab=overview&from=2025-04-01&to=2025-04-30"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from Apr 1, 2025 to Apr 30, 2025
      </a>
<div>
<a
        href="https://github.com/rwightman?tab=overview&from=2025-04-01&to=2025-04-30"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/rwightman?tab=overview&from=2025-04-01&to=2025-04-30
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
>
<bdi className="js-issue-title markdown-title">Initial work on adding local-dir: schema for model & tokenizer loading from local folder</bdi>

  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/mlfoundations/open_clip/pull/1069" target="_blank" rel="noopener noreferrer">
  #1069
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/rwightman" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">rwightman</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/mlfoundations/open_clip/pull/1069" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Apr 17, 2025</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>

<p>Here are the details of a specific commit from the <a href="https://github.com/mlfoundations/open_clip/pull/1069" target="_blank">mlfoundations/open_clip repository</a>:</p>
<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/guillaumeguy" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">GG - guillaumeguy</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>commented </span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/mlfoundations/open_clip/pull/1069" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Apr 26, 2025</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>
<p dir="auto">FYI: Looks good to me anecdotally:</p>

  </>
  );
};

export default Rwightman_pull_mlfoundations_open_clip_pull_1069_From_2025_04_01_To_2025_04_30;
